import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const organizerBrandFragment = gql`
  fragment organizerBrand on OrganizerBrand {
    id
    name
    logoUrl
    isFollowedByViewer
    displayRequestForMarketingConsent
  }
`

export const organizerBrandFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  isFollowedByViewer: PropTypes.bool.isRequired,
  displayRequestForMarketingConsent: PropTypes.bool.isRequired,
})

export default organizerBrandFragment
